import { render } from "./BasicLayout.vue?vue&type=template&id=83cf5b8c&class=bg"
const script = {}

import "./BasicLayout.vue?vue&type=style&index=0&id=83cf5b8c&lang=css"

import exportComponent from "/var/www/potabilis/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__